import {orderApprovePageTitle} from '../approval/refs/approve.page.title'
import {orderApproveApiUrl} from '../approval/refs/approve.api'
import {orderApprovePageParams} from '../approval/refs/approve.page.parameter'
import {orderApproveEncryptionType} from '../approval/refs/approve.page.encryption'
import {orderApproveCardConfig} from '../approval/refs/approve.page.cardConfig'
import {orderApproveDialogData} from '../approval/refs/approve.page.dialog'
import {orderApprovePageControl} from '../approval/refs/approve.page.control'
import {formModel} from '../approval/refs/orderDetails.formModel'
import {orderApprovePageMainForm} from '../approval/refs/approve.form.main'
import {orderApproveData} from '../approval/refs/approve.form.approveData'
import {orderApprovePageHelperData} from '../approval/refs/approve.page.helper'
import { regionDataPlus, provinceAndCityData } from 'element-china-area-data'

var orderDetailsData = {
  // 页面标题
  pageTitle: orderApprovePageTitle,
  // 页面所有api地址
  apiUrl: orderApproveApiUrl,
  // 页面参数
  pageParams: orderApprovePageParams,
  // 解密类型
  encryptionType: orderApproveEncryptionType,
  // 卡片配置
  cardConfig: orderApproveCardConfig,
  // 对话框数据
  dialogData: orderApproveDialogData,
  // 页面控制数据
  pageControl: orderApprovePageControl,
  // 页面展示数据
  pageData: formModel,
  // 大表单
  pageMainForm: orderApprovePageMainForm,
  // 审批数据
  approveData: orderApproveData,
  // 页面辅助数据
  pageHelperData: orderApprovePageHelperData,
  // 省市区
  regionDataPlus,
  // 省市
  provinceAndCityData
}

export {
  orderDetailsData
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/orderDetails.vue.data.js